const state = {
  visitFormData: {},
  visitType: -1,
  invalidOpportunity: 0,
  visitObjectStatus: -1
}
const getters = {
}
const mutations = {
  updateFormData (state, payload) {
    state.visitFormData = payload
  },
  updateVisitType (state, payload) {
    state.visitType = payload
  },
  updateInvalidOpportunity (state, payload) {
    state.invalidOpportunity = payload
  },
  updateVisitObjectStatus (state, payload) {
    state.visitObjectStatus = payload
  }
}
const actions = {
}
export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
}
